import styled from 'styled-components';

const percentageSize = 28;
export const Percentage = styled.div`
  opacity: 0;
  @keyframes show-up {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  animation: 400ms ease 1s show-up forwards;
  width: ${percentageSize}px;
  height: ${percentageSize}px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 100%;
  box-shadow: 0px 3.45798px 6.91595px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(
      ${-percentageSize / 2}px,
      calc((${({ size }) => size}px - ${percentageSize}px) / 2)
    )
    rotate(${(props) => props.rotate}deg);
  transform-origin: ${percentageSize / 2}px
    calc(-${({ size }) => size / 2}px + ${percentageSize / 2}px);

  > div {
    transform: rotate(-${(props) => props.rotate}deg);
    font-size: 11px !important;
  }

  @media ${(props) => props.theme.device.mobileL} {
    top: ${({ size }) => size / 2}px;
  }
`;

const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !['size', 'mt'].includes(prop),
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: ${({ size }) => size}px;
  margin-top: ${({ mt }) => mt}px;

  @media ${(props) => props.theme.device.tabletL} {
    position: relative;
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
  }
`;

const ChartContainer = styled.div`
  position: relative;
  width: 50%;

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
  }

  &.has-select {
    top: -27px;
  }
`;

const Chart = styled.div.withConfig({
  shouldForwardProp: (prop) => !['size'].includes(prop),
})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  canvas {
    width: ${({ size }) => size}px !important;
    height: ${({ size }) => size}px !important;
  }

  @media ${(props) => props.theme.device.mobileL} {
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
  }

  &:hover ${Percentage} {
    opacity: 0 !important;
  }
`;

const ProgressCourseContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  p {
    font-style: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    &.number {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    top: ${({ size }) => size / 2}px;
    left: 50%;
  }
`;

const CourseNumber = styled.span`
  color: ${(props) => props.theme.colors.textPrimary};
`;

const CourseIcon = styled.span`
  font-size: 32px;
  color: ${(props) => props.theme.colors.textPrimary};
`;

const CourseActive = styled.span`
  text-align: center;
  color: ${(props) => props.theme.colors.textPrimary};

  &:first-letter {
    text-transform: capitalize;
  }
`;

const ProgressBarContainer = styled.div`
  width: 50%;

  .progress-content {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
  }

  & > div:last-child {
    border: none;
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
    margin-top: 220px;

    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 8px;
    > div {
      width: 100%;
    }
  }
`;

const NumberItem = styled.span`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: ${(props) => props.theme.colors.textPrimary};
`;

const StateLabel = styled.div`
  margin: 0 auto;
  padding: 4px 0;
  color: ${(props) => props.theme.colors.textPrimary};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const Legend = styled.div.withConfig({
  shouldForwardProp: (prop) => !['color'].includes(prop),
})`
  width: 20px;
  height: 11px;
  flex-shrink: 0;
  border-radius: 3px;
  background: ${({ color }) => color};
  //? prevent background from being ignored @print
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
`;

export {
  Container,
  ChartContainer,
  ProgressCourseContainer,
  Chart,
  CourseNumber,
  CourseIcon,
  CourseActive,
  ProgressBarContainer,
  NumberItem,
  StateLabel,
};
